export default {"src":"/_next/static/media/literatureBg.e4c98fc8.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};